export function resolveCustomerContact({
  customer,
  fallbackProfile,
}: {
  customer?: {
    email?: string;
    phone?: string;
  } | null;
  fallbackProfile: {
    email: string;
    phoneNumber: string;
  };
}) {
  return {
    email: customer?.email || fallbackProfile.email,
    phoneNumber: customer?.phone || fallbackProfile.phoneNumber,
  };
}
